export default "__VITE_ASSET__d96917e0__"